import { render, staticRenderFns } from "./event_info.vue?vue&type=template&id=2dc5c244&"
import script from "./event_info.vue?vue&type=script&lang=js&"
export * from "./event_info.vue?vue&type=script&lang=js&"
import style0 from "./event_info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports